import { RootState } from "../../../app/store/store";

export const selecToolBar = (state: RootState) => state.toolBar;
